// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.list-wrapper[data-v-5eb24974] {\n  background-color: #fff;\n  padding: 20px;\n}\n.list-title[data-v-5eb24974] {\n  font-size: 14px;\n  color: #333;\n  margin-bottom: 10px;\n  display: flex;\n  justify-content: space-between;\n}\n.red-text[data-v-5eb24974] {\n  color: #f53f3f;\n}\n.scan-summary[data-v-5eb24974] {\n  padding: 0 calc(50% - 600px);\n}\n", ""]);
// Exports
module.exports = exports;
